import maps from '@/generated/maps.js'
import { computed, ref } from 'vue'
import axios from 'axios'

export function useUploadTeamAsset (category, overrideAllowExtensionList = null) {
  const progress = ref(0)
  const isUploading = ref(false)

  const allowExtensionList = computed(() => {
    if (overrideAllowExtensionList !== null) {
      return overrideAllowExtensionList
    }
    const type = maps.App_Models_TeamAsset.categoriesTypeMap[category.value]
    return maps.App_Models_TeamAsset.extensionAllowListMap[type]
  })

  const accept = computed(() => {
    return allowExtensionList
      .value
      .map(extension => `.${extension}`)
      .join(',')
  })

  const uploadTeamAsset = async (file, { errorMessageOption } = {}) => {
    try {
      if (file.size > 5 * 1024 * 1024) {
        await window.SwalTimer.fire({
          icon: 'error',
          title: 'The file size should not be greater than 5MB',
          text: 'Please try again.'
        })

        return
      }

      isUploading.value = true

      const url = Spark.router('api.team.asset.store')
      const formData = new FormData()

      formData.append('shared', 0)
      formData.append('category', category.value)
      formData.append('disk', Spark.getDisk())
      formData.append('file', file)

      const res = await axios.post(url, formData, {
        onUploadProgress: (progressEvent) => {
          progress.value = Math.floor(progressEvent.loaded / progressEvent.total * 100)
        }
      })

      return res.data
    } catch (e) {
      console.error(e)

      if (e.response?.status === 422) {
        const errorMessage = Object.values(e.response.data)[0]

        await window.SwalTimer.fire({
          icon: 'error',
          title: errorMessage,
          text: 'Please try again.',
          ...errorMessageOption
        })
      }
    } finally {
      isUploading.value = false
      progress.value = 0
    }
  }

  return {
    progress,
    isUploading,
    allowExtensionList,
    accept,
    uploadTeamAsset
  }
}
